const Footer = () => {
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <a href='https://vitaverify.me' target='_blank' rel='noopener noreferrer'>
          Vita Verify
        </a>
        <span className='d-none d-sm-inline-block'>, All rights Reserved</span>
      </span>
      <span className='float-md-right d-none d-md-block'>
        {/* Replaced by Hubspot Chatbot (Reference at public index.html file) */}
      </span>
    </p>
  )
}

export default Footer
